import { useEffect, useState } from "react";
import { t } from "i18next";
import { PaginationControl } from "react-bootstrap-pagination-control";

const CustomPagination = (props) => {

    const { handlePageChange, between = 4, totalLength, totalPages, pageNo, limit = 10 } = props;
    const [page, setPage] = useState(pageNo || 1)
    useEffect(() => {
        handlePageChange(page)
    }, [page])
    const handlePreviousPage = () => {
        if (page > 1) {
            setPage(page - 1);
        }
    };
    const handleNextPage = (len) => {
        if (page < len) {
            setPage(page + 1);
        }
    };

    return (
        <div className="pagnation-table d-flex align-items-center justify-content-between">
            <button className={page === 1 ? "table-btn disabled" : "table-btn"} onClick={handlePreviousPage}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                >
                    <path
                        d="M15.8332 9.99935H4.1665M4.1665 9.99935L9.99984 15.8327M4.1665 9.99935L9.99984 4.16602"
                        stroke="#344054"
                        custom-tab-section
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>{" "}
                {t("previous")}
            </button>
            <PaginationControl
                page={page}
                between={between}
                total={totalLength}
                limit={limit}
                changePage={(page) => {
                    setPage(page);
                }}
                ellipsis={1}
                next={false}
                last={false}
            />
            <button
                className={page === parseInt(totalPages) ? " table-btn disabled" : "table-btn"}
                onClick={() => handleNextPage(totalPages)}
            >
                {t("next")}{" "}
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                >
                    <path
                        d="M4.16675 9.99935H15.8334M15.8334 9.99935L10.0001 4.16602M15.8334 9.99935L10.0001 15.8327"
                        stroke="#344054"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </button>
        </div>
    )
}

export default CustomPagination;